enum Paths {
    cmsCreate = '/cms/create',
    cms = '/cms',
}

export default Paths;


// WEBPACK FOOTER //
// ./src/modules/Cms/paths.ts